import { render, staticRenderFns } from "./FirmOrderList.vue?vue&type=template&id=0700e566&"
import script from "./FirmOrderList.vue?vue&type=script&lang=js&"
export * from "./FirmOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports